// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__OaD_6","carouselSection":"Carousel_carouselSection__uX3Tc","navigation":"Carousel_navigation__fBzJm","swiper":"Carousel_swiper__6rSFN"};